<aux-extendable-options-dropdown
  classList="!w-full"
  [items]="options()"
  [dropdownControl]="unitsOfMeasureControl"
  [openOnInit]="true"
  [resetValueOnEscapePress]="true"
  [initialSearchTerm]="initialSearchTerm"
  (clickOut)="stopEditing()"
  (confirm)="stopEditing()"
  (addOption)="onAddOption($event)"
  (changed)="$event && stopEditing()"
/>
